import React from 'react'
import { connect } from 'react-redux'
import OfflineSnackbar from './OfflineSnackbar'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserCompanies } from '../../common/auth/authSelectors'
import { hasFeatureFlag } from '../../common/helpers/featureFlags'
import { UserCompanyDto } from '../../services/api.types'

interface IOfflineSnackbarWrapperProps {
  userCompanies: UserCompanyDto[] | null
}

/**
 * Wrapper component for the OfflineSnackbar that checks for feature flags
 * before rendering the notification
 */
const OfflineSnackbarWrapper: React.FC<IOfflineSnackbarWrapperProps> = ({ userCompanies }) => {
  // Check if offline messages are disabled via feature flag
  const isOfflineMessageDisabled = hasFeatureFlag(userCompanies, 'disableOfflineMessage')

  // Only render the snackbar if offline messages are not disabled
  if (isOfflineMessageDisabled) {
    return null
  }

  return <OfflineSnackbar />
}

const mapStateToProps = (state: IGlobalState) => ({
  userCompanies: getUserCompanies(state),
})

export default connect(mapStateToProps)(OfflineSnackbarWrapper)
